"use client"
import React from 'react';
import { Box, Checkbox } from '@mui/material';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { useNavigate } from 'react-router-dom';

interface Product {
  image: string;
  rating: string;
  brand: string;
  name: string;
  price: number;
  originalPrice: number;
  discount: number;
  match?: number
}

interface ProductCardProps {
  className?: string;
  products: Product[];
}

const ProductCard: React.FC<ProductCardProps> = ({ products, className }) => {

  const navigate = useNavigate();
  const label = { inputProps: { 'aria-label': 'Favorite Checkbox' } };

  return (
    <div className="productCard_grid gap_m mt_20">
      {products.map((item, index) => (
        <div className={`productCard_item ${className ?? ''}`} key={index}>
          <Box className='overlay_link' component="a" onClick={() => navigate("/product-listing/product-detail")}></Box>
          <figure className="card_figure">
            <img src={item.image} alt={item.name} />
            <div className="rating">
              <span>Best</span>
              <strong>
                {item.rating} <StarRoundedIcon />
              </strong>
            </div>
            {item.match && (
              <div className="match">
                <span><img src="/images/star_ai_icon.svg" alt="Icon" /> {item.match}% Match</span>
              </div>
            )}
          </figure>

          <div className="card_info">
            <div className="flex_head hd_6">
              <h3>{item.brand}</h3>
              <Checkbox
                {...label}
                icon={<img src="/static/images/heart_outline_icon.svg" alt="unchecked" />}
                checkedIcon={<img src="/static/images/heart_filled_icon.svg" alt="checked" />}
              />
            </div>
            <p>{item.name}</p>
            <p className="price">
              <ins>${item.price}</ins>
              <del>${item.originalPrice}</del>
              <span className="discount">{item.discount}% OFF</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductCard;
